import React from 'react';

import Container from 'components/ui/Container';

import * as Styled from './styles';

const Footer = () => (
  <Styled.Footer>
    <Container>
      <Styled.Links>
        <Styled.Link href="/contact">
          Find Us
        </Styled.Link>
        <p>•</p>
        <Styled.Link href="mailto:info@planet-pickle.com" rel="noreferrer noopener" target="_blank">
          Email
        </Styled.Link>
      </Styled.Links>
    </Container>
  </Styled.Footer>
);

export default Footer;
